import apiClient from "../config/apiClient";

export const printExcuseDuty = async (id) => {
  const user = window.localStorage.getItem("token");
  const token = user;
  return await apiClient.get(
    `/public/portal?url=patient/excuse-duties/${id}/print`,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
};
